"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BadgeVariant", {
  enumerable: true,
  get: function get() {
    return _Badge.Variant;
  }
});
exports.Kind = void 0;
var _GlobalKind = _interopRequireDefault(require("../type-tools/GlobalKind"));
var _Badge = require("../Badge/Badge.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Kind = exports.Kind = function (Kind) {
  Kind[Kind["DEFAULT"] = _GlobalKind["default"].DEFAULT] = "DEFAULT";
  Kind[Kind["INVERSE"] = _GlobalKind["default"].INVERSE] = "INVERSE";
  return Kind;
}(Kind || {});